import { useEffect, useState } from 'react'
import { getUser } from './utils/queries'
import { useParams } from 'react-router-dom'
import QuickSheet from './QuickSheet'
import MasterInputs from './MasterInputs'

export const ShowUser = () => {
  const { id } = useParams()
  const [user, setUser] = useState({})
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    let timeoutId
    const fetchUser = async () => {
      const data = await getUser(id)
      setUser(data.data.getParcoUser)
      timeoutId = setTimeout(() => setLoading(false), 300)
    }
    fetchUser()
    return clearTimeout(timeoutId)
  }, [id])

  return (
    <MasterInputs
      loading={loading}
      userIntakeState={user}
      key={user.id || 'no-user-found'}
    />
  )
}
